import { Switch, Route } from "react-router-dom";

import style from "./common.module.scss";

import FrontPage from "./FrontPage";
import SearchResults from "./SearchResults";
import News from "./News";

function NewSite() {
    return (
        <Switch>
            <Route path="**/news">
                <News />
            </Route>
            <Route path="**/results">
                <SearchResults />
            </Route>
            <Route path="/">
                <FrontPage />
            </Route>
        </Switch>
    )
}

export default NewSite;